import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LargeCopyIcon, PopupList, InfoIcon as PrestyledInfoIcon, UnmutedCameraIcon, } from '@streamr/tv-ui';
import styled from 'styled-components';
import { copyToClipboard } from '../utils/copyToClipboard';
import { formBroadcastUrl } from '../utils/url';
import { Button } from './Button';
export function BroadcastNameplate({ onActivateBroadcastClick, broadcast, }) {
    const url = formBroadcastUrl(broadcast);
    return (_jsxs(StyledPopupList, { children: [_jsxs(Row, { children: [_jsx(Url, { children: url.replace(/^https?:\/\//, '') }), _jsx(CopyButton, { type: "button", onClick: () => {
                            copyToClipboard(url);
                        }, children: _jsx(LargeCopyIcon, {}) })] }), _jsxs("div", { children: [_jsxs(Row, { children: [_jsx(InfoIcon, { fillOpacity: 0.6 }), _jsx(Disclaimer, { children: "Anyone who has this link can watch your live stream." })] }), !!onActivateBroadcastClick && (_jsx(Segment, { children: _jsx(GoLiveButton, { type: "button", icon: _jsx(UnmutedCameraIcon, { fill: "#f65f0a" }), size: "mini", onClick: onActivateBroadcastClick, children: "Go live" }) }))] })] }));
}
const StyledPopupList = styled(PopupList) `
    max-width: 100%;
    min-width: 0;
`;
const Row = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`;
const GoLiveButton = styled(Button) `
    border-radius: 0.5rem;
    width: 100%;
`;
const InfoIcon = styled(PrestyledInfoIcon) `
    flex-shrink: 0;
`;
const Disclaimer = styled.div `
    font-size: 0.875rem;
    line-height: 1.25rem;
`;
const CopyButton = styled.button `
    align-items: center;
    appearance: none;
    background: none;
    border: 0;
    color: inherit;
    display: flex;
    flex-shrink: 0;
    font: inherit;
    justify-content: center;
    padding: 0;

    &:active {
        transform: translateY(0.0625rem);
    }
`;
const Url = styled.div `
    flex: 1;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25rem;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const Segment = styled.div `
    align-items: center;
    background-color: rgba(53, 54, 49, 0.55);
    box-sizing: border-box;
    display: flex;
    gap: 1rem;
    min-height: 1.25rem;
    margin-top: 1rem;    
`;
